import { render } from 'preact'
import HybridLandingPage from 'landing_pages/components/HybridLandingPage'

function getRootContainer() {
  return document.querySelector('.root-container')
}

export default function renderRoot() {
  const rootContainer = getRootContainer()
  if(!rootContainer) {
    return
  }

  render(
    <HybridLandingPage
      isMultiClient={window['templateName'] === 'portal'}
      variables={window['variables']}
      clients={window['clients']}
      clientWeights={window['clientWeights']}
      leadTargets={window['leadTargets']}
      clientCampaignRules={window['clientCampaignRules']}
      degreeProgramRules={window['degreeProgramRules']}
      templateName={window['templateName']}
    />, rootContainer, rootContainer.querySelector('.root') ?? undefined
  )
}
